import { render, staticRenderFns } from "./channelContent.vue?vue&type=template&id=c75bfc7c&scoped=true"
import script from "./channelContent.vue?vue&type=script&lang=js"
export * from "./channelContent.vue?vue&type=script&lang=js"
import style0 from "./channelContent.vue?vue&type=style&index=0&id=c75bfc7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75bfc7c",
  null
  
)

export default component.exports